import TablePagination from "@mui/material/TablePagination";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";

const CustomPagination = ({ count, page, rowsPerPage, onPageChange, onRowsPerPageChange }) => {
  const theme = useTheme();

  return (
    <TablePagination
      showFirstButton
      showLastButton
      component="div"
      count={count}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={[5, 10, 25, 50, 100]}
      sx={{
        color: theme.palette.text.pagination,
        ".MuiTablePagination-selectLabel, .MuiTablePagination-input": {
          color: theme.palette.text.pagination,
        },
        ".MuiSelect-icon": {
          color: theme.palette.text.pagination,
        },
        ".MuiTablePagination-actions .Mui-disabled": {
          color: theme.palette.text.disabled,
        },
      }}
    />
  );
};

// ✅ 2. PropTypes validation to fix ESLint prop errors
CustomPagination.propTypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
};

export default CustomPagination;
